"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 9.6307c0-2.4446-2.2769-4.1-4.4361-3.5114-1.7822.4857-3.9073.94-5.5639.94s-3.7817-.4543-5.5639-.94C4.277 5.5308 2 7.186 2 9.6307c0 1.1759.5681 2.415 1.7331 2.9558a4.1468 4.1468 0 0 0-.2538 1.4351C3.4793 16.2188 5.1748 18 7.2663 18h9.4674c2.0915 0 3.787-1.7812 3.787-3.9784 0-.506-.0899-.9899-.2538-1.4351C21.4319 12.0457 22 10.8066 22 9.6307zm-2.8882 1.2945c.5851-.2061.9947-.5855.9947-1.2945 0-1.043-1.013-1.8732-2.0671-1.586-1.8108.4936-4.1298 1.0038-6.0394 1.0038-1.9095 0-4.2286-.5102-6.0393-1.0038-1.0542-.2873-2.0672.543-2.0672 1.586 0 .709.4096 1.0884.9947 1.2945.65-.5517 1.4773-.8821 2.378-.8821h9.4675c.9008 0 1.7281.3304 2.3781.8821zm-13.739 3.0964c0-1.0987.8477-1.9893 1.8935-1.9893h9.4674c1.0458 0 1.8935.8906 1.8935 1.9893 0 1.0986-.8477 1.9892-1.8935 1.9892H7.2663c-1.0458 0-1.8935-.8906-1.8935-1.9892z"
  })];
};

exports.default = _default;